export default "__VITE_ASSET__fyq5M$f6__"